import { CdkStepperModule } from "@angular/cdk/stepper";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { defineElement } from "@lordicon/element";
import { DemoCostAndUsageReportsComponent } from "./demo-cost-and-usage-reports/demo-cost-and-usage-reports.component";
import { DemoDashboardComponent } from "./demo-dashboard/demo-dashboard.component";
import { DemoManageChangeSpendLimitComponent } from "./demo-manage-change-spend-limit/demo-manage-change-spend-limit.component";
import { DemoManageChangeTariffPlanComponent } from "./demo-manage-change-tariff-plan/demo-manage-change-tariff-plan.component";
import { DemosRoutingModule } from "./demos-routing.module";
import { DemoSimManagementComponent } from "./demo-sim-management/demo-sim-management.component";
import { DemoUserManagementComponent } from "./demo-user-management/demo-user-management.component";
import { DropdownsModule } from "src/app/core/dropdowns/dropdowns.module";
import { FormsModalModule } from "src/app/forms-modal/forms-modal.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridViewModule } from "src/app/core/grid-view/grid-view.module";
import lottie from 'lottie-web';
import { NgStepperModule } from "angular-ng-stepper";
import { PageComponentsModule } from "src/app/core/page-components/page-components.module";
import { SharedModule } from "src/app/shared/shared.module";
import { ToastsContainer } from "src/app/shared/toast/toasts-container.component";
import { DemoLiveViewComponent } from "./demo-live-view/demo-live-view.component";

@NgModule({
  declarations: [
    DemoCostAndUsageReportsComponent,
    DemoDashboardComponent,
    DemoLiveViewComponent,
    DemoManageChangeSpendLimitComponent,
    DemoManageChangeTariffPlanComponent,
    DemoSimManagementComponent,
    DemoUserManagementComponent
  ],
  imports: [
    CdkStepperModule,
    CommonModule,
    DemosRoutingModule,
    DropdownsModule,
    FormsModalModule,
    FormsModule,
    GridViewModule,
    NgStepperModule,
    PageComponentsModule,
    ReactiveFormsModule,
    SharedModule,
    ToastsContainer
  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class DemosModule {
  constructor() {
    defineElement(lottie.loadAnimation);    
  }
}
